import { useSignupModal } from "@/features/signup/SignupModal";
import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import { ButtonLink } from "@/shared/components/ButtonLink/ButtonLink";
import styles from "./FounderClass.module.css";

export function FounderClass() {
  const { founderClass } = useMaestriaContent();
  const openSignup = useSignupModal();

  const eyebrowStrong = founderClass.eyebrowStrong ?? "será gratuita,";
  const columnStrong = founderClass.columnStrong ?? "turma fundadora";
  const limitedStrong = founderClass.limitedStrong ?? "Vagas limitadas";

  const [eyebrowLead, eyebrowTail] = founderClass.eyebrow.split(eyebrowStrong);
  const [column2Lead, column2Tail] = founderClass.columns[1].split(columnStrong);
  const limitedTail = founderClass.limited.slice(limitedStrong.length);

  return (
    <section
      id="turma-fundadora"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="founder-title"
    >
      <div className={`maestria-container ${styles.inner}`}>
        <h2 id="founder-title" className={styles.eyebrow}>
          {eyebrowLead}
          <strong>{eyebrowStrong}</strong>
          {eyebrowTail}
        </h2>

        <div className={styles.ticket}>
          <img
            src={founderClass.ticket}
            alt={`${founderClass.title} — ${founderClass.price}`}
            width={632}
            height={393}
            loading="lazy"
          />
        </div>

        <hr className={styles.rule} />

        <div className={styles.columns}>
          <p>{founderClass.columns[0]}</p>
          <p>
            {column2Lead}
            <strong>{columnStrong}</strong>
            {column2Tail}
          </p>
          <p>{founderClass.columns[2]}</p>
        </div>

        <hr className={styles.rule} />

        <p className={styles.limited}>
          <strong>{limitedStrong}</strong>
          {limitedTail}
        </p>

        <ButtonLink onClick={openSignup} className={styles.cta}>
          {founderClass.cta.label}
        </ButtonLink>
      </div>
    </section>
  );
}
